import dayjs, { locale } from 'dayjs';
import 'dayjs/locale/ko';

const getCurrentDate = () => {
  locale('ko');
  const now = dayjs();
  const startOfMonth = now.startOf('month');
  const firstDayWeekday = startOfMonth.day() === 0 ? 6 : startOfMonth.day() - 1; // Convert Sunday (0) to last (6), Monday as start
  const weekNumber = Math.ceil((now.date() + firstDayWeekday) / 7);

  return {
    month: now.month() + 1,
    week: weekNumber,
  };
};

export default getCurrentDate;
